var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.sentimento
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column flex-md-row az-gap-small detail-tab-sentimento__cards"
            },
            [
              _c(
                "TranscriptSummaryCard",
                {
                  staticClass:
                    "detail-tab-sentimento__card detail-tab-sentimento__card--left",
                  attrs: { title: "Score de Sentimento" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-center" },
                    [
                      _c("TranscriptSentimentGauge", {
                        attrs: {
                          sentimento: _vm.sentimento,
                          score: _vm.sentimentoScore,
                          engajamento: _vm.engajamento,
                          size: 120,
                          "show-scale": ""
                        }
                      }),
                      _vm.confiancaValor !== null
                        ? _c(
                            "div",
                            { staticClass: "w-100 mt-4" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center justify-space-between mb-1"
                                },
                                [
                                  _c("span", { staticClass: "az-text-small" }, [
                                    _vm._v(
                                      " Confiança (" +
                                        _vm._s(_vm.confiancaValor.toFixed(2)) +
                                        ") "
                                    )
                                  ]),
                                  _c("span", { staticClass: "az-text-small" }, [
                                    _vm._v(_vm._s(_vm.confiancaLabel))
                                  ])
                                ]
                              ),
                              _c("v-progress-linear", {
                                attrs: {
                                  value: _vm.confiancaValor * 100,
                                  color: _vm.sentimentoHex,
                                  height: "8",
                                  rounded: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "TranscriptSummaryCard",
                {
                  staticClass:
                    "detail-tab-sentimento__card detail-tab-sentimento__card--right",
                  attrs: { title: "Análise da IA", icon: "ia-head" }
                },
                [
                  _vm.sentimentoJustificativa
                    ? _c(
                        "div",
                        { staticClass: "detail-tab-sentimento__analysis" },
                        [
                          _c(
                            "p",
                            { staticClass: "az-text-primary az-size-14 mb-0" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.sentimentoJustificativa) + " "
                              )
                            ]
                          )
                        ]
                      )
                    : _c(
                        "p",
                        { staticClass: "az-text-secondary az-size-14 mb-0" },
                        [_vm._v(" Análise da IA ainda não disponível. ")]
                      )
                ]
              )
            ],
            1
          )
        : _c(
            "TranscriptStateFeedback",
            _vm._b({}, "TranscriptStateFeedback", _vm.sentimentoFeedback, false)
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }